export interface Route {
    name: string;
    path: string;
    icon?: string;
    subroutes?: Route[]
}
export enum DefaultRoutes {
    home = "/home",
    dataVisualization = "/data-visualization",
    user = "/user",
    favorites = "/favorites",
    tasks = "/tasks",
    admin = "/admin",
    help = "/help",
    chat = "/chat"
}

export enum FeatureRoutes {
    reports = "/reports",
    boards = "/boards",
    chat = "/chat",
}

export const Routes: Route[] = [
    {
        name: 'Inicio',
        path: DefaultRoutes.home,
        icon: 'assets/icons/home.svg'
    },
    {
        name: 'Tipos de información',
        path: DefaultRoutes.dataVisualization,
        icon: 'assets/icons/analytics.svg',
        subroutes: [
            {
                name: 'Reportes',
                path: FeatureRoutes.reports,
            },
            {
                name: 'Tableros',
                path: FeatureRoutes.boards,
            },
        ]
    },
    {
        name: 'Favoritos',
        path: DefaultRoutes.favorites,
        icon: 'assets/icons/star.svg',
        subroutes: [
            {
                name: 'Reportes',
                path: FeatureRoutes.reports,
            },
            {
                name: 'Tableros',
                path: FeatureRoutes.boards,
            },
        ]
    },
    {
        name: 'Tareas',
        path: DefaultRoutes.tasks,
        icon: 'assets/icons/list-check.svg'
    },
    {
        name: 'Chat Gen BAI',
        path: DefaultRoutes.chat,
        icon: 'assets/icons/ia.svg'
    },
];

export const AdminRoutes: Route[] = [
    ...Routes,
    {
        name: 'Usuarios',
        path: `${DefaultRoutes.user}/registered`,
        icon: 'assets/icons/user.svg'
    },
    {
        name: 'Configuración',
        path: DefaultRoutes.admin,
        icon: 'assets/icons/settings.svg',
        subroutes: [
            {
                name: 'Parámetros lista',
                path: '/parameters',
            },
            {
                name: 'Grupos de reportes',
                path: '/report-groups',
            }
        ]
    },
]

export const SpecialistRoutes: Route[] = [
    ...Routes,
    {
        name: 'Usuarios',
        path: `${DefaultRoutes.user}/registered`,
        icon: 'assets/icons/user.svg',
    },
    {
        name: 'Configuración',
        path: DefaultRoutes.admin,
        icon: 'assets/icons/settings.svg',
        subroutes: [
            {
                name: 'Parametros lista',
                path: '/parameters',
            },
            {
                name: 'Grupos de reportes',
                path: '/report-groups',
            }
        ]
    },
]